import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Deltra = () => {
  useEffect(() => {
    // App carousel slider
    const slider = document.getElementById("slider");
    if (!slider) return;

    let currentIndex = 0;
    const slides = slider.children;
    const totalSlides = slides.length;

    const slide = () => {
      if (totalSlides > 0) {
        currentIndex = (currentIndex + 1) % (totalSlides - 2);
        slider.style.transform = `translateX(-${currentIndex * 33.333}%)`;
      }
    };

    const slideInterval = setInterval(slide, 3000);

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  return (
    <div className="deltra-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeIn" data-wow-delay="0.5s">
            <h1>
              <img src="/assets/images/logos/logo-deltra.webp" alt="deltra" />
            </h1>
            <h2>Your Cryptocurrency Bot</h2>
            <div className="breadcrumb">
              <span>
                Portfolio / <strong>Deltra</strong>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="whatwedo-section">
        <div className="container">
          <div className="row">
            <div className="col col-4">
              <h2>What We Did</h2>
              <ul className="list">
                <li>UX & UI Design</li>
                <li>Product Architecture</li>
                <li>Mobile Development</li>
                <li>Backend Development</li>
                <li>Security</li>
              </ul>
            </div>
            <div className="col col-8">
              <h2>Overview</h2>
              <p>
                Deltra is a powerful crypto trading bot that provides various strategies to buy low and sell high
                in the day-to-day market. With Deltra, you can generate maximum profits without being affected
                by emotions or market fluctuations. The bot can connect to multiple crypto exchanges, while
                keeping your API and Secret keys safe and secure.
              </p>
              <p>
                Your funds always remain in your crypto exchange account, providing you with complete control
                over your assets. Deltra's highly secure platform ensures that your data and assets are always
                protected, giving you peace of mind while you trade.
              </p>
              <p>
                Deltra's highly secure platform uses advanced encryption to protect your sensitive data, ensuring
                that
                your trades are executed with the utmost security and reliability. And with our easy-to-use
                interface, getting started with Deltra is simple and straightforward.
              </p>
            </div>
          </div>
          <div className="portfolio-carousel">
            <div className="slide-content">
              <img src="/assets/images/background/detra/main.webp" alt="detra" />
            </div>
          </div>
        </div>
      </section>

      <section className="challenges-section">
        <div className="container">
          <div className="challenges">
            <div className="col col-6">
              <div className="img-card">
                <img src="/assets/images/background/detra/m1.webp" alt="detra" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Challenges</h3>
                <div className="scroll">
                  <p>
                    Deltra's development involved several challenges that needed to be addressed. One of the
                    biggest challenges was developing a trading strategy, which is essential for maximizing
                    profits in the cryptocurrency market. This required extensive research into market
                    trends and analysis of historical price data to develop an effective strategy.
                  </p>
                  <p>
                    Another major challenge was ensuring the security of user data and funds. Deltra was
                    designed to operate using users' API keys, which presented a potential security risk.
                  </p>
                  <p>
                    The project also faced challenges related to scalability and performance. As the number
                    of users and trades increases, it was essential to ensure that the system could handle
                    the increased load without compromising performance or stability.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-6 flex-reverse">
              <div className="img-card">
                <img src="/assets/images/background/detra/m2.webp" alt="detra" />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Solutions</h3>
                <div className="scroll">
                  <p>
                    Our team understands the importance of providing solutions that meet the needs of our
                    clients. We have addressed the challenges of security, scalability, and high volume
                    trades in our project.
                  </p>
                  <p>
                    To ensure the security of our platform, we use the ECC algorithm, Secp256k1, which is
                    widely used in cryptography. This assures our clients that the system is highly secure.
                  </p>
                  <p>
                    Scalability is essential, and to address this challenge, we
                    have used AWS Lambda serverless architecture. This allows us to handle large volumes of
                    trades with ease, ensuring a seamless experience for our users.
                  </p>
                  <p>
                    In addition, we have implemented multithreading to process trades and ensure zero time
                    delay. This approach helps us handle high volumes of trades while maintaining a high
                    level of accuracy and efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section">
        <div className="container">
          <div className="title">
            <h2>Browse on any device</h2>
            <p>
              Experience responsive, pixel-perfect UI designs on any device with our custom software solutions
            </p>
          </div>
          <div className="app-carousel" id="slider">
            <div className="slide-content">
              <img src="/assets/images/background/detra/s1.webp" alt="detra" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/detra/s2.webp" alt="detra" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/detra/s3.webp" alt="detra" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/detra/s4.webp" alt="detra" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/detra/s5.webp" alt="detra" />
            </div>
            <div className="slide-content">
              <img src="/assets/images/background/detra/s6.webp" alt="detra" />
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Deltra;
